import React, { Fragment } from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import { observable } from '@formily/reactive';
import { Observer } from '@formily/react';
const PortalMap = observable(new Map());
export const createPortalProvider = (id) => {
    const Portal = (props) => {
        if (props.id && !PortalMap.has(props.id)) {
            PortalMap.set(props.id, null);
        }
        return (React.createElement(Fragment, null,
            props.children,
            React.createElement(Observer, null, () => {
                if (!props.id)
                    return null;
                const portal = PortalMap.get(props.id);
                if (portal)
                    return createPortal(portal, document.body);
                return null;
            })));
    };
    Portal.defaultProps = {
        id,
    };
    return Portal;
};
export function createPortalRoot(host, id) {
    function render(renderer) {
        if (PortalMap.has(id)) {
            PortalMap.set(id, renderer?.());
        }
        else if (host) {
            ReactDOM.render(React.createElement(Fragment, null, renderer?.()), host);
        }
    }
    function unmount() {
        if (PortalMap.has(id)) {
            PortalMap.set(id, null);
        }
        else if (host) {
            ReactDOM.unmountComponentAtNode(host);
            host.parentNode?.removeChild(host);
        }
    }
    return {
        render,
        unmount,
    };
}
